import React, { useMemo, useState, useEffect } from 'react';
import Table from '../../../../components/Tables/ReportTable';
import { headerMaker } from '../../../../components/Tables/ExpandedTable/helper';
import reportService from '../../../../services/reports';
import { useSelector } from 'react-redux';
import Spinner from 'components/Spinner';
import { Empty } from 'antd';
import { usePaginate } from 'hooks/usePaginate';

export default ({ active: group }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newHeader, setNewHeader] = useState([]);
  const { data, handleOnTableChange, pageCount } = usePaginate();

  const { categories } = useSelector((state) => state.appReducer);

  useEffect(() => {
    setLoading(true);
    let data = {
      group,
    };
    if (group !== '') {
      reportService
        .getAllUserPlans(data)
        .then((resp) => {
          createUserData(resp);
          makeReportHeaders(resp);
        })
        .finally(() => setLoading(false))
        .catch((err) => console.log(err));
    }
  }, [group]);

  const makeReportHeaders = (plans = []) => {
    const hechCategories = new Map();
    categories.forEach((item) => hechCategories.set(item?._id, item));
    let foo = [];
    plans?.forEach((item) =>
      item?.data?.map((subItem) => foo.push(subItem?.subCategory))
    );
    foo = new Set([...foo]);
    const headerCats = [...foo].map((item) => hechCategories.get(item));

    let subHeaders = [
      {
        Header: 'Т/р',
        accessor: 'id',
        // rowSpan: '2',
        show: true,
        width: 50,
      },
      {
        Header: 'FISH',
        accessor: 'name',
        width: 350,
        textAlign: 'left',

        // rowSpan: '2',
        show: true,
      },
    ];
    if (subHeaders.length == 2) {
      headerCats &&
        headerCats.forEach((item) => {
          subHeaders.push({
            Header: item.title,
            show: true,
            height: 150,
            width: 300,
            accessor: item._id + 'plan',
          });
        });
    }
    setNewHeader(subHeaders);
  };

  const headers = useMemo(() => headerMaker(newHeader), [newHeader]);

  const createUserData = (data = []) => {
    const rowData = data?.map((item, ind) => {
      let row = {
        id: ind + 1,
        name: `${item.user?.firstName} ${item.user?.lastName} ${item.user?.middleName}`,
      };
      item.data.forEach((itm) => {
        row[itm.subCategory + 'plan'] = itm.plan;
      });
      return row;
    });
    setRows(rowData);
  };
  if (loading) return <Spinner maxHeight='100%' />;
  return rows.length > 0 ? (
    <Table
      data={data}
      headers={headers}
      withExcel={true}
      onChange={handleOnTableChange}
      total={rows.length}
      reportsData={rows}
      page={pageCount}
      tableName='Режа(план)лар бўйича'
    />
  ) : (
    <Empty
      description='Маълуьмот топилмади'
      image={Empty.PRESENTED_IMAGE_SIMPLE}
    />
  );
};
